import { useConversationAttention } from '../shared/conversation-attention'
import type { OverviewRepository } from './overview-repository'

const REFRESH_INTERVAL_MS = 60_000

// The same query as the notification badge: one outstanding-work count.
export function useOverviewAttention(
  repository: OverviewRepository,
  tenantId: string
) {
  return useConversationAttention(
    (id) => repository.getAttention(id),
    tenantId,
    REFRESH_INTERVAL_MS
  )
}
